var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#icon-fallback-image-fd9f4';
                    var viewUrl = 'svg-sprite-bdf610186567e509224ddd134655642d.svg#view-icon-fallback-image-fd9f4';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 102 76',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };